import React from 'react';
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';

const ProRangePicker: React.FC<RangePickerProps> = React.forwardRef<
  any,
  RangePickerProps
>((props, ref) => {
  return (
    <DatePicker.RangePicker ref={ref} {...props} />
  );
});

export default ProRangePicker;
